import _get from 'lodash/get';
import { sendImpressions, sendClick } from 'reaxl-analytics';

const dealerLotAnalytics = {
    // Dealer Module - impression (pixall only)
    fireReaxleLotContainerImpression(listing = {}, { pageName }) {
        sendImpressions({
            name: 'ownerImpressions',
            data: {
                selectedItemIds: [listing.id],
                pixallData: {
                    eventSource: 'dealership',
                    label: 'dl_c_lstg',
                    listingType: 'elot',
                    listingCode: listing.ownerId,
                },
                ownerIds: [listing.ownerId],
            },
        });
    },

    // Vehicle Impression
    fireReaxleLotCarouselImpressions(listings = [], { pageName }, startingIndex) {
        sendImpressions({
            name: 'inventoryImpressions',
            data: {
                cmp: 'dl_v_lstg_',
                selectedItemIds: listings.map(({ id }) => id),
                pixallData: {
                    eventSource: 'vehicle',
                    label: 'dl_v_lstg',
                    listingType: 'elot',
                    pageType: pageName,
                },
                startingIndex,
            },
        });
    },

    // Vehicle Click
    fireReaxleLotInventoryClick(event, listing = {}, { pageName }, indexClicked) {
        sendClick('inventoryClick', event, {
            par: 'dl_v_lstg',
            inventoryId: listing.id,
            pixallData: {
                listingType: 'elot',
                eventSource: 'vehicle',
            },
            indexClicked,
        });
    },

    // Dealer Logo - click (GA and pixall)
    fireReaxleLotTileClick(event, owner) {
        sendClick('eLotTileClick', event, {
            owner,
            ownerId: owner.id,
            par: 'dl_v_lstg',
        });
    },

    // Carousel arrow clicks
    fireReaxleLotArrowClick(event, cmp, isRecentSearches) {
        sendClick('inventoryArrowClick', event, {
            direction: cmp,
            isRecentSearches,
        });
    },

    // Save and Unsave
    fireReaxleLotSaveClick(event, listing = {}, wasSaved, par = 'dl_v_lstg') {
        sendClick('inventorySave', event, {
            inventoryId: listing.id,
            wasSaved,
            par,
            pixallData: {
                eventType: 'save',
                listingType: 'elot',
            },
        });
    },
    // Deprecated: Utility function to extent listing object to include BIRF parames
    getInventoryListingBirfParams(owner, inventoryListing) {
        const birfParams = {
            c: _get(owner, 'id', ''),
            par: 'dl_c_lstg',
            v: inventoryListing.id,
            lstg_type: 'r',
            es: 'vehicle',
            lt: 'elot',
            s: inventoryListing.stockId,
            n: inventoryListing.vin,
            ct: inventoryListing.listingType,
        };
        return birfParams;
    },
};

export default dealerLotAnalytics;
